module.exports = __webpack_public_path__ + "static/media/federated-associations.1daf497d.png";